export default __webpack_public_path__ + "static/media/LMT-BNB.eb0c75b1.svg";